/* DO NOT EDIT THIS FILE DIRECTLY
 * This file is generated from a template
 * https://roverdotcom.atlassian.net/wiki/spaces/TECH/pages/1961002737/Business+Concept+Change+Process
 */
export enum TEAMS {
  booking_experience = 'booking_experience',
  client_platform = 'client_platform',
  cloud_infrastructure = 'cloud_infrastructure',
  sitter_experience = 'sitter_experience',
  data_platform = 'data_platform',
  expansion = 'expansion',
  discovery = 'discovery',
  recommendations = 'recommendations',
  no_owner = 'no_owner',
  trust_safety_operations = 'trust_safety_operations',
  orders = 'orders',
  payments = 'payments',
  retention = 'retention',
  site_reliability = 'site_reliability',
  acceleration = 'acceleration',
  training = 'training',
  integrations = 'integrations',
}

export type Concept = readonly [string, TEAMS];

export const CONCEPTS = {
  bookings: {
    creation: ['Bookings: Creation', TEAMS.booking_experience],
    edit: ['Bookings: Edit', TEAMS.orders],
    cancellation: ['Bookings: Cancellation', TEAMS.orders],
    dates: ['Bookings: Dates', TEAMS.booking_experience],
    defunct: ['Bookings: Defunct', TEAMS.booking_experience],
    meet_and_greet: ['Bookings: Meet & Greet', TEAMS.booking_experience],
    notifications: ['Bookings: Notifications', TEAMS.booking_experience],
    repeat: ['Bookings: Rebooking', TEAMS.booking_experience],
    recurring: ['Bookings: Recurring', TEAMS.sitter_experience],
    reviews: ['Bookings: Reviews', TEAMS.trust_safety_operations],
    tipping: ['Bookings: Tipping', TEAMS.sitter_experience],
    pricing: ['Bookings: Pricing', TEAMS.sitter_experience],
    assignment: ['Bookings: Assignment', TEAMS.sitter_experience],
    inbox: ['Bookings: Inbox', TEAMS.sitter_experience],
    grooming: ['Bookings: Grooming', TEAMS.expansion],
    service_delivery: ['Bookings: Service Delivery', TEAMS.retention],
    anti_diversion: ['Bookings: Anti-Diversion', TEAMS.sitter_experience],
    trust_and_safety: ['Bookings: Trust and Safety', TEAMS.trust_safety_operations],
    external_platform: ['Bookings: External Platform', TEAMS.expansion],
  },
  communications: {
    thread: ['Communications: Thread', TEAMS.sitter_experience],
    support: ['Communications: Support', TEAMS.trust_safety_operations],
    email: ['Communications: Email', TEAMS.retention],
    notifications_center: ['Communications: Notifications Center', TEAMS.retention],
    phones: ['Communications: Phones', TEAMS.retention],
    push: ['Communications: Push', TEAMS.retention],
    sms: ['Communications: SMS', TEAMS.retention],
    ugc: ['Communications: UGC', TEAMS.retention],
    video_calls: ['Communications: Video Calls', TEAMS.retention],
    trust_and_safety: ['Communications: Trust and Safety', TEAMS.trust_safety_operations],
    notifications: ['Communications: Notifications', TEAMS.retention],
  },
  finance: {
    general_ledger: ['Finance: General Ledger', TEAMS.orders],
    month_close: ['Finance: Month Close', TEAMS.orders],
    subledger: ['Finance: Subledger', TEAMS.orders],
  },
  marketing: {
    growth: ['Marketing: Growth', TEAMS.discovery],
    m_and_a: ['Marketing: M&A', TEAMS.integrations],
    supply: ['Marketing: Supply', TEAMS.sitter_experience],
    referrals: ['Marketing: Referrals', TEAMS.acceleration],
    promos: ['Marketing: Promos', TEAMS.payments],
    crm: ['Marketing: CRM', TEAMS.retention],
    corporate: ['Marketing: Corporate', TEAMS.trust_safety_operations],
    craigslist: ['Marketing: Craigslist', TEAMS.discovery],
  },
  orders: {
    order_and_line_items: ['Orders: Order & Line Items', TEAMS.orders],
    sales_tax: ['Orders: Sales Tax', TEAMS.orders],
    vat: ['Orders: VAT', TEAMS.orders],
    database: ['Orders: Database', TEAMS.orders],
  },
  payments: {
    donations: ['Payments: Donations', TEAMS.payments],
    know_your_customer: ['Payments: Know Your Customer', TEAMS.payments],
    payins: ['Payments: Payins', TEAMS.payments],
    payouts: ['Payments: Payouts', TEAMS.payments],
  },
  people_and_pets: {
    authentication: ['People & Pets: Authentication', TEAMS.acceleration],
    compliance: ['People & Pets: Compliance', TEAMS.trust_safety_operations],
    preferences: ['People & Pets: Preferences', TEAMS.trust_safety_operations],
    profile: ['People & Pets: Profile', TEAMS.trust_safety_operations],
    trust_and_safety: ['People & Pets: Trust and Safety', TEAMS.trust_safety_operations],
    external_platform_profile: ['People & Pets: External Platform Profile', TEAMS.expansion],
  },
  platform: {
    api: ['Platform: API', TEAMS.client_platform],
    mobile: ['Platform: Mobile', TEAMS.client_platform],
    accessibility: ['Platform: Accessibility', TEAMS.client_platform],
    design_systems: ['Platform: Design Systems', TEAMS.client_platform],
    reactjs_server_side_rendering: [
      'Platform: React.js Server Side Rendering',
      TEAMS.client_platform,
    ],
    web_client: ['Platform: Web Client', TEAMS.client_platform],
    deeplinks: ['Platform: Deeplinks', TEAMS.client_platform],
    development: ['Platform: Development', TEAMS.cloud_infrastructure],
    documentation: ['Platform: Documentation', TEAMS.cloud_infrastructure],
    international: ['Platform: International', TEAMS.cloud_infrastructure],
    eventstream: ['Platform: Eventstream', TEAMS.data_platform],
    analytics: ['Platform: Analytics', TEAMS.recommendations],
    experiments: ['Platform: Experiments', TEAMS.recommendations],
    geospatial: ['Platform: Geospatial', TEAMS.retention],
    admin: ['Platform: Admin', TEAMS.trust_safety_operations],
    redirects: ['Platform: Redirects', TEAMS.site_reliability],
    async_tasks: ['Platform: Async Tasks', TEAMS.site_reliability],
    sre: ['Platform: SRE', TEAMS.site_reliability],
  },
  recommendations: {
    alternatives: ['Recommendations: Alternatives', TEAMS.booking_experience],
    assignment: ['Recommendations: Assignment', TEAMS.recommendations],
    browse_search: ['Recommendations: Browse Search', TEAMS.retention],
    contactability: ['Recommendations: Contactability', TEAMS.recommendations],
    marketplace_management: ['Recommendations: Marketplace Management', TEAMS.recommendations],
    repeat: ['Recommendations: Repeat', TEAMS.recommendations],
    insights: ['Recommendations: Provider Insights', TEAMS.recommendations],
    platform: ['Recommendations: Platform', TEAMS.recommendations],
    provider_profile: ['Recommendations: Provider Profile', TEAMS.retention],
    training: ['Recommendations: Dog Training Search', TEAMS.expansion],
    job_board: ['Recommendations: Job Board', TEAMS.sitter_experience],
  },
  service_offerings: {
    pricing: ['Service Offerings: Pricing', TEAMS.sitter_experience],
    overnight_traveling: ['Service Offerings: Overnight Traveling', TEAMS.sitter_experience],
    assignment: ['Service Offerings: Assignment', TEAMS.sitter_experience],
    grooming: ['Service Offerings: Grooming', TEAMS.expansion],
    training: ['Service Offerings: Training', TEAMS.training],
    insurance: ['Service Offerings: Insurance', TEAMS.acceleration],
    availability: ['Service Offerings: Availability', TEAMS.sitter_experience],
    provider_profile: ['Service Offerings: Provider Profile', TEAMS.sitter_experience],
    walking: ['Service Offerings: Walking', TEAMS.sitter_experience],
    background_checks: ['Service Offerings: Background Checks', TEAMS.trust_safety_operations],
  },
} as const;
